import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const SelectListItemHeader = ({ className, children, disabled, ...rest })=>{
    return jsx("div", {
        className: classNames('cb-select-list-item-header', {
            disabled
        }, className),
        ...rest,
        children: jsx("div", {
            className: "header-container",
            children: jsx("span", {
                className: "header",
                children: children
            })
        })
    });
};
SelectListItemHeader.displayName = 'SelectList.Item.Header';

export { SelectListItemHeader };
//# sourceMappingURL=SelectList.Item.Header.es.js.map
